import { __assign } from "tslib";
import React, { Fragment } from 'react';
import { IconSVG } from '../icon-svg/icon-svg';
export var IconElectric = function (SVGprops) {
    return (React.createElement(IconSVG, __assign({ viewBox: "-4 0 24 24" }, SVGprops),
        React.createElement(Fragment, null,
            React.createElement("path", { d: "M6.99998 23.6101V15.0001H0.22998L8.99998 0.390137V9.00014H15.77L6.99998 23.6101ZM3.76998 13.0001H8.99998V16.3901L12.23 11.0001H6.99998V7.61014L3.76998 13.0001Z" }))));
};
